import { createEnumMap } from 'Commons/helpers/utils/Formatter';

const cardTypeList = ['unit', 'lead', 'tenant', 'estimate', 'reservation'];
const CARD_TYPE = createEnumMap(cardTypeList);

export default CARD_TYPE;
